const BlogSection = [
  {
    id: 1,
    title: 'Free proxies are not safe to use! (unless with caution)',
    link: 'https://proxyscrape.com/blog/free-proxies-are-not-safe-to-use/',
    img: 'https://proxyscrape.com/blog/wp-content/uploads/are-free-proxies-safe-01.png',
  },
  {
    id: 2,
    title: 'Proxy anonymity levels: transparent vs anonymous vs elite proxies',
    link: 'https://proxyscrape.com/blog/proxy-anonymity-levels/',
    img: 'https://proxyscrape.com/blog/wp-content/uploads/2021/02/anonymity-types-01.png',
  },
  {
    id: 3,
    title: 'Ad Verification with Residential Proxies',
    link: 'https://proxyscrape.com/blog/ad-verification-with-residential-proxies/',
    img: 'https://proxyscrape.com/blog/wp-content/uploads/Ad-Verification-with-Residential-Proxies.jpg',
  },
];

export default BlogSection;
